import { FormHelperText, styled } from '@mui/material';

export const FormHelperTextStyled = styled(FormHelperText, {
  shouldForwardProp: (prop) => prop !== 'helperType' && prop !== 'marginInline',
})(({ theme, helperType, marginInline }) => {
  const getColor = () => {
    if (helperType === 'warning') return theme.palette.colors.highlight;
    if (helperType === 'error') return theme.palette.colors.down;
    if (helperType === 'info') return theme.palette.colors.onPrimaryBackground;
    if (helperType === 'inactive') return theme.palette.colors.lower;
    return theme.palette.colors.secondaryBackground;
  };

  return {
    fontSize: 10,
    color: getColor(),
    marginInline,
  };
});
